import { render, staticRenderFns } from "./TalkVideo.vue?vue&type=template&id=6ada8952&scoped=true&"
import script from "./TalkVideo.vue?vue&type=script&lang=ts&"
export * from "./TalkVideo.vue?vue&type=script&lang=ts&"
import style0 from "./TalkVideo.vue?vue&type=style&index=0&id=6ada8952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ada8952",
  null
  
)

export default component.exports